<script setup lang="ts">
    import { reactive, ref, defineProps, defineEmits } from 'vue';
    import axios from 'axios';

    const props = defineProps({ accessToken: { type: String, required: true } });
    const emit = defineEmits(['otpVerified']);

    const digitsLength = ref(6);
    const errorMessage = ref('');
    const loading = ref(false);
    const isFormValid = ref(false);
    const otpInputs = ref<any[]>([]);
    const formErrors = reactive({
        otp_code: '',
    });

    function validate() {
        let isValid = true;

        formErrors.otp_code = '';
        if (otpInputs.value.length == 0) {
            formErrors.otp_code ="Le code OTP est requis";
            isValid = false;
        }

        isFormValid.value = isValid;
        
        return isValid;
    }

    async function onSubmit() {
        if (!validate()) { return; }
        loading.value = true;
        errorMessage.value = '';
        try {
            const httpResponse = await axios.post(`/backoffice/auth/verification_otp`, { otp_code: otpInputs.value.map(i => i.value).join('') }, {
                headers: {
                    Authorization: `Bearer ${props.accessToken}`
                }
            });
            if (httpResponse.data.success == true) {
                emit("otpVerified");
            } else {
                errorMessage.value = 'Le code OTP saisi est incorrect';
                
                for (var i = 0; i < otpInputs.value.length; i++) {
                    otpInputs.value[i].value = null;
                    if (i == 0) {
                        otpInputs.value[i].focus();
                    }
                }
            }
        } catch(error: any) {
            errorMessage.value = error.message;
            console.error(error);
        } finally {
            loading.value = false;
        }
    }

    // Quand on tape un chiffre
    function onInput(event: any, index: number) {
        const input = event.target
        const value = input.value

        // Si on a bien 1 caractère, on passe au suivant
        if (value.length === 1 && index < otpInputs.value.length - 1) {
            otpInputs.value[index + 1].focus()
        }

        // Facultatif : empêcher de taper autre chose qu’un chiffre
        if (!/^[0-9]$/.test(value)) {
            input.value = ''
        }

        if (index + 1 == digitsLength.value) {
            onSubmit();
        }
    }

    // Quand on appuie sur backspace
    function onBackspace(event: any, index: number) {
        const input = event.target
        if (input.value === '' && index > 0) {
            otpInputs.value[index - 1].focus()
        }
    }
</script>

<template>
    <div>
        <h1 class="font-semibold my-8 text-center">Vérification OTP <span class="text-sm text-grey-500"></span></h1>
        <form class="form" @submit.prevent="onSubmit">
            <div class="my-5">
                <label>Entrez le code de sécurité <b class="color-danger">*</b></label>
                <div class="flex gap-6">
                    <input v-for="(digit, index) in digitsLength" :autofocus="index == 0" :key="index" type="text" :id="'otp_code_' + index" class="form-control-code" maxlength="1" @input="onInput($event, index)" @keydown.backspace="onBackspace($event, index)" ref="otpInputs" :readonly="loading" />
                </div>
            </div>
            <span v-if="!!formErrors['otp_code']" class="text-red">{{ formErrors['otp_code'] }}</span>

            <div class="mt-7">
                <div v-if="!!errorMessage" class="text-red text-center mb-5">{{ errorMessage }}</div>
                <div class="flex ">
                    <div class="s20">
                        <custom-button :loading="loading" :classesList="'btn xl w-100'" type="submit">
                            <img src="/icons/icon-menu-securite.svg" class="btn-icon" alt="" />
                            <span>Valider</span>
                        </custom-button>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>
